export default __webpack_public_path__ + "static/media/image.ebaby-lk.4487c3a2.png";